import { useEffect, useRef } from "react";
import { Check, Star } from "lucide-react";
import { mediaUrl } from "@/lib/galleryApi";
import { RetryImg } from "@/components/gallery/RetryImg";

export function Filmstrip({ photos, current, onPick, selected, onToggle }) {
  const activeRef = useRef(null);
  useEffect(() => { activeRef.current?.scrollIntoView({ block: "nearest", inline: "nearest" }); }, [current]);
  return (
    <div className="flex lg:flex-col gap-1.5 overflow-auto p-2" data-testid="photo-strip">
      {photos.map((p, i) => (
        <div key={p.id} ref={i === current ? activeRef : null} onClick={() => onPick(i)} data-testid={`strip-photo-${p.id}`}
          className={`relative shrink-0 w-16 h-16 lg:w-full lg:h-auto lg:aspect-square rounded-md overflow-hidden cursor-pointer ring-2 transition-shadow ${i === current ? "ring-[#F97316]" : selected.has(p.id) ? "ring-[#0099CC]" : "ring-transparent hover:ring-[#1A2332]"}`}>
          <RetryImg src={mediaUrl(p.thumb_url)} loading="lazy" className="w-full h-full object-cover" />
          <button onClick={(e) => { e.stopPropagation(); onToggle(p.id); }} className="absolute top-1 left-1" data-testid={`strip-select-${p.id}`} aria-label="Selectionner">
            <span className={`w-4 h-4 rounded-sm border flex items-center justify-center ${selected.has(p.id) ? "bg-[#0099CC] border-[#0099CC]" : "border-white/50 bg-black/40"}`}>
              {selected.has(p.id) && <Check className="w-2.5 h-2.5 text-white" />}
            </span>
          </button>
          {p.is_favorite && <Star className="absolute top-1 right-1 w-3 h-3 text-[#F59E0B] fill-[#F59E0B]" />}
          {p.has_processed && <span className="absolute bottom-1 right-1 w-2 h-2 rounded-full bg-[#F97316]" title="Version HD generee" />}
          {!p.has_processed && Object.keys(p.adjustments || {}).length > 0 && <span className="absolute bottom-1 right-1 w-2 h-2 rounded-full border border-[#F97316]" title="Reglages enregistres" />}
        </div>
      ))}
    </div>
  );
}
